export const START_ACTION = 'START_ACTION';
export const STOP_ACTION = 'STOP_ACTION';
export const SET_ERROR = 'SET_ERROR';
export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
